interface ItemMetadata {
  id: String
  name: String
  type: "text" | "options" | "date"
  tenantSpecific?: Boolean
  typeParameters?: any
  optionSettings?: any
}
interface FormType {
  value: "Option" | "PhotoUpload" | "TextForm"
  formLabel: String
  multiple: Boolean
}

interface TemplateItem {
  itemMetadata: ItemMetadata,
  formType: FormType,
  required: Boolean
}

export const generateIssueTemplateItem = ({id, name, formLabel, type, formTypeValue, required, options}) => {

  const optionSettings = options ?  {
    enabled: true,
    options: options && options.map(option => ({
        value: option.value,
        label: null
      }))
  } : null


     const item: TemplateItem = {
        itemMetadata: {
          id,
          name,
          type,
          optionSettings
        },
        formType: {
          value: formTypeValue,
          formLabel: formLabel,
          multiple: false
        },
        required
      }


  return item
}